export default __webpack_public_path__ + "static/media/ICCloud.dbe1184b.svg";